import { render, staticRenderFns } from "./PartPlaceHolder.vue?vue&type=template&id=18155c6b&scoped=true&"
import script from "./PartPlaceHolder.vue?vue&type=script&lang=js&"
export * from "./PartPlaceHolder.vue?vue&type=script&lang=js&"
import style0 from "./PartPlaceHolder.vue?vue&type=style&index=0&id=18155c6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18155c6b",
  null
  
)

export default component.exports